const routes = [
    {
        path: "/cities",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "city_index"
        }
    }
];

export default routes;
